<script setup>
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import EditorField from '@js/components/fields/EditorField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { toastError } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { ticket, ticketAnswer, callback } = defineProps({
    ticket: {
        type: Object,
        required: true,
    },
    ticketAnswer: {
        type: Object,
        required: false,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const isOpen = ref(false);

const form = reactive({
    message: ticketAnswer ? ticketAnswer.message : ticket.message,
});

const validationSchema = object({
    message: string().required('Le message est requis'),
});

function submit() {
    isSubmitting.value = true;

    axios
        .patch(
            ticketAnswer
                ? route('front.projectManagement.task.patchTicketAnswer', {
                      ticketAnswer: ticketAnswer.id,
                  })
                : route('front.projectManagement.task.patchTicket', {
                      ticket: ticket.id,
                  }),
            {
                message: form.message,
            },
        )
        .then(() => {
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}
</script>

<template>
    <DialogModal v-model="isOpen">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            Modifier la réponse du ticket #{{ ticket.id }}
        </template>

        <template #full-content>
            <FormRoot
                v-slot="{ errors }"
                :validation-schema="validationSchema"
                :submit="submit"
            >
                <FormColumn>
                    <FormContent>
                        <EditorField
                            v-model="form.message"
                            field-name="message"
                            field-id="message"
                            label="Message"
                            size="small"
                            disable-html-toggle
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogModal>
</template>
